import { initialTranslations } from '@app/constants';
import i18n from '@app/i18n';
import {
  QuestionBody,
  QuestionDetailsView,
  QuestionTranslationView,
  QuestionType,
  TranslationBody,
  VisibilityType,
} from '@data/sdk/match';
import { Language } from '@data/utils/enums';
import { QuestionFormValues } from '../hooks';

const getQuestionTranslations = (translations: QuestionTranslationView[]) =>
  translations.reduce((acc: { [key in Language]: string }, el: QuestionTranslationView) => {
    acc[el.language as Language] = el.value;
    return acc;
  }, {} as { [key in Language]: string });

export const getInitialValues = (
  question: QuestionDetailsView | undefined,
  translations: QuestionTranslationView[] | undefined,
) => ({
  unit: question?.unit || '',
  questionType: question?.questionType || QuestionType.Standard,
  visibilityType: question?.visibilityType || VisibilityType.Default,
  text: translations ? getQuestionTranslations(translations) : initialTranslations,
  expiry: question?.expiry || null,
});

export const getQuestionVisibilityOptions = () => [
  { label: i18n.t('admin:question_visibility.default'), value: VisibilityType.Default },
  { label: i18n.t('admin:question_visibility.first'), value: VisibilityType.First },
  { label: i18n.t('admin:question_visibility.hidden'), value: VisibilityType.Hidden },
];

export const transformQuestionFormValues = (
  formValues: QuestionFormValues,
): {
  questionValues: Partial<QuestionBody>;
  translationsValues: TranslationBody[];
} => {
  const questionValues = {
    unit: formValues.unit,
    visibilityType: formValues.visibilityType,
    text: formValues.text[Language.EN],
    questionType: formValues.questionType,
    expiry: formValues.expiry,
    autoGenerateTranslations: false, // to allow custom translation it should be false, and if necessary it will be overwritten in POST translations request in autoGenerate property
  };

  const translationsValues = Object.values(Language).reduce<TranslationBody[]>((acc, language) => {
    acc.push({
      language,
      value: formValues.text[language] || formValues.text[Language.EN],
      autoGenerate: !formValues.text[language],
    });

    return acc;
  }, []);

  return { questionValues, translationsValues };
};
